export default "__VITE_ASSET__6f72385a__"